const firmas = {

    NuevoMensaje: 'SIVAC/Mensajes/Firmas/NuevoMensaje',
    BuscarProcesadosParaEnviarMensaje: 'SIVAC/Mensajes/BuscarProcesadosParaEnviarMensaje'
    
}

const mensajes = {
    
    firmas: firmas
}

export default mensajes;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIVAC/Sistema/Mensajes/mensajes.js
// module id = null
// module chunks = 